import { render } from "./DepotCustomerPriceChangeLog.vue?vue&type=template&id=2106424c"
import script from "./DepotCustomerPriceChangeLog.vue?vue&type=script&lang=js"
export * from "./DepotCustomerPriceChangeLog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__